import React from 'react'
import styled from '@emotion/styled'
import { css, useTheme } from '@emotion/react'
import { RadioChecked, RadioUnchecked } from 'assets/icons/common'
import { withAttrs } from '../../utils'

const Label = styled.label`
  display: flex;
  font-size: ${p => p.theme.fontSizes[1]};
  cursor: pointer;
`

const RadioIcon = props => {
  const theme = useTheme()

  return (
    <React.Fragment>
      <RadioChecked
        {...props}
        css={css`
          display: none;
          margin-right: ${theme.space[3]};

          input:checked ~ & {
            display: block;
          }
        `}
      />
      <RadioUnchecked
        {...props}
        css={css`
          display: 'block';
          margin-right: ${theme.space[3]};

          input:checked ~ & {
            display: none;
          }
        `}
      />
    </React.Fragment>
  )
}

const Input = styled(withAttrs('input', { type: 'radio' }))`
  position: absolute;
  opacity: 0;
  z-index: -1;
  width: 1;
  height: 1;
  overflow: hidden;
`

const Radio = ({ className, children, ...rest }) => (
  <Label className={className}>
    <Input {...rest} />
    <RadioIcon />
    {children}
  </Label>
)

export default Radio
